import { takeLatest, call, put } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import { adminLoginReq, setTokenAdmin, resetAdminPassReq } from 'api';
import { URLS } from 'config';
import { showLoadScreen, hideLoadScreen } from 'components/LoadScreen/actions';
// import { generateNextRoute } from 'utilz';

import * as actions from './actions';


function* adminSingIn(action) {
  const { payload: { callback: { loginAdmin, passAdmin } } } = action;
  const body = {
    login: loginAdmin,
    password: passAdmin
  };
  try {
    yield put(showLoadScreen());
    const result = yield call(adminLoginReq, body);
    yield put(hideLoadScreen());
    setTokenAdmin(result.data.token);
    yield put(push(URLS.CAREDITOR));
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

function* changePassReq(action) {
  const { payload: { mail } } = action;
  try {
    yield put(showLoadScreen());
    const body = {
      login: mail
    };
    const result = yield call(resetAdminPassReq, body);
    console.log(result);
    yield put(hideLoadScreen());
    // setTokenAdmin(result.data.token);
    // yield put(push(URLS.LOGINADMIN));
  } catch (err) {
    yield put(hideLoadScreen());
    console.log(err);
  }
}

export default function* () {
  yield takeLatest(
    actions.ADMIN_LOGIN,
    adminSingIn
  );
  yield takeLatest(
    actions.CHANGE_PASS_REQ,
    changePassReq
  );
}



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/saga.js